import { jsx as _jsx } from "react/jsx-runtime";
import EkspanderendeBlockComponent, {} from '../../../behandlingsvalg/ekspanderendeblock';
const EkspanderendeBlock = ({ value }) => (_jsx(EkspanderendeBlockComponent, { title: value.title, mainContent: value.mainContent }));
export default EkspanderendeBlock;
